import styled, { css } from 'styled-components';

const shouldForwardProp = prop =>
  !['$markerColor', '$textAlign', '$flexColumn'].includes(prop);

const BulletListStyled = styled.ul.withConfig({ shouldForwardProp })`
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;

  ${props =>
    props.$textAlign &&
    css`
      text-align: ${props.$textAlign};
    `}

  ${props =>
    props.$flexColumn &&
    css`
      display: flex;
      flex-direction: column;
    `}

  li {
    list-style-type: disc;

    ${props =>
      props.$markerColor &&
      css`
        &::marker {
          color: ${props.$markerColor};
        }
      `}
  }
`;

export default BulletListStyled;
